module.exports = __webpack_public_path__ + "img/stock6.7f903dff.png";